module.exports = __webpack_public_path__ + "img/刘士友.25e47599.jpg";